import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions";
import * as API from "../api";
import Helper from "../../helpers/helpers";



export function* submitInvoice() {

  yield takeEvery(actionTypes.SUBMIT_INVOICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SUBMITINVOICE");    
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.submitInvoice(action.data);
     
      if (response.data.success) {
        if(response.data.data)
        {
          yield put(actions.submitInvoiceSuccess(response.data.data));
        }else{
          yield put(actions.submitInvoiceSuccess());
          yield put(actions.toastSuccess(response.data.message));
        }
      } else {
        console.log(111)
        alert(response.data.message);
        yield put(actions.submitInvoiceFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      console.log(222, error)
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.submitInvoiceFail());
    }
  });
}

export function* getDocumentDetail() {
  
  yield takeEvery(actionTypes.GET_TAX_DOCUMENT_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo(`TAXDOCUMENTDETAIL`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.getDocumentDetail(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.getDocumentDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getDocumentDetailFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getDocumentDetailFail());
    }
  });
}

export function* cancelSubmission() {

  yield takeEvery(actionTypes.CANCEL_SUBMISSION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("CANCELSUBMISSION");    
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.cancelSubmission(action.data);
     
      if (response.data.success) {
        yield put(actions.cancelSubmissionSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.cancelSubmissionFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.cancelSubmissionFail());
    }
  });
}

export function* validateTIN() {

  yield takeEvery(actionTypes.VALIDATE_TIN, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VALIDATETIN");    
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.validateTIN(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.validateTINSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.validateTINFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.validateTINFail());
    }
  });
}

export function* addTaxpayer() {

  yield takeEvery(actionTypes.ADD_TAXPAYER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("ADDTAXPAYER");    
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.addTaxpayer(action.data);
     
      if (response.data.success) {
        yield put(actions.addTaxpayerSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.addTaxpayerFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.addTaxpayerFail());
    }
  });
}

export function* setDefaultTaxpayer() {

  yield takeEvery(actionTypes.SET_DEFAULT_TAXPAYER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETDEFAULTTAXPAYER");    
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.setDefaultTaxpayer(action.id, action.data);
     
      if (response.data.success) {
        yield put(actions.setDefaultTaxpayerSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.setDefaultTaxpayerFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setDefaultTaxpayerFail());
    }
  });
}


export function* loadTaxSettings() {

  yield takeEvery(actionTypes.LOAD_TAX_SETTINGS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LOADTAXSETTINGS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());
    
    try {
      const response = yield API.loadTaxSettings(action.data);
     
      if (response.data.success && response.data.data) {
        yield put(actions.loadTaxSettingsSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadTaxSettingsFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadTaxSettingsFail());
    }
  });
}



export default function* eInvoiceSaga() {
  
  yield all([fork(submitInvoice)]); 
  yield all([fork(getDocumentDetail)]); 
  yield all([fork(cancelSubmission)]); 
  yield all([fork(validateTIN)]); 
  yield all([fork(addTaxpayer)]); 
  yield all([fork(setDefaultTaxpayer)]); 
  yield all([fork(loadTaxSettings)]); 
}
